import {
    Globe,
    Server,
    Code,
    TrendingUp,
    Search,
    Share2,
    Mail,
    Shield,
    Smartphone,
    Menu,
    X,
    ChevronDown,
    Users,
    Briefcase,
    Award,
    Lightbulb,
    Palette,
    Code2,
    Rocket,
    ShoppingCart,
    Database
} from 'lucide-react';

export const IconMap = {
    Globe,
    Server,
    Code,
    TrendingUp,
    Search,
    Share2,
    Mail,
    Shield,
    Smartphone,
    Menu,
    X,
    ChevronDown,
    Users,
    Briefcase,
    Award,
    Lightbulb,
    Palette,
    Code2,
    Rocket,
    ShoppingCart,
    Database
};
